import React from "react";
import { formattedDateTime } from "../../utils/utilities";
import moment from "moment";
const BetTableList = ({ data }) => {

    return (
        <div className="table-responsive">
            <div className="table-wrapper">
                <div className="table">
                    <React.Fragment >
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Runner</th>
                                    <th>Odds</th>
                                    <th>Stack</th>
                                    <th>Bet Type</th>
                                    <th>Market Type</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.length > 0 ? data.map((bet, index) => (
                                    <tr key={index} className={bet.BetType === "No" || bet.BetType === "Lay" ? "lay" : "back"}>
                                        <td>{index + 1}</td>
                                        <td>{bet?.SelectionName}</td>
                                        <td>{bet?.MarketType === 'FANCY' ? bet?.Odds + '(' + bet?.Price + ')' : bet?.Odds}</td>
                                        <td>{bet?.Stack}</td>
                                        <td>{bet?.BetType}</td>
                                        <td>{bet?.MarketType}</td>
                                        <td>{formattedDateTime(bet?.createdOn)}</td>
                                        
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-white-50">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </React.Fragment>

                </div>
            </div>
        </div>
    )
}

export default BetTableList;